/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Robot_Hud_Eta_RemainingInputs */

const en_robot_hud_eta_remaining = /** @type {(inputs: Robot_Hud_Eta_RemainingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remaining ETA`)
};

const fr_robot_hud_eta_remaining = /** @type {(inputs: Robot_Hud_Eta_RemainingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ETA restante`)
};

const ms_sg2_robot_hud_eta_remaining = /** @type {(inputs: Robot_Hud_Eta_RemainingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ETA berbaki`)
};

/**
* | output |
* | --- |
* | "Remaining ETA" |
*
* @param {Robot_Hud_Eta_RemainingInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const robot_hud_eta_remaining = /** @type {((inputs?: Robot_Hud_Eta_RemainingInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Robot_Hud_Eta_RemainingInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_robot_hud_eta_remaining(inputs)
	if (locale === "fr") return fr_robot_hud_eta_remaining(inputs)
	return ms_sg2_robot_hud_eta_remaining(inputs)
});